import { alpha, lighten, styled } from '@mui/material';
import React, { useEffect, useState } from 'react';

type ContainerStyle = {
    containerStyle: Pick<
        React.CSSProperties,
        'width' | 'backgroundColor' | 'height' | 'boxShadow' | 'marginBottom' | 'marginTop' | 'maxWidth'
    >;
    buttonStyle?: React.CSSProperties;
    animationStyle?: React.CSSProperties;
};

interface ToggleProps {
    labels?: [string, string];
    // checked: boolean;
    onChange: (value: string) => void;
    value: string;
    options: { label: React.ReactNode; value: string }[];
    style?: ContainerStyle;
}

export const Container = styled('div', {
    shouldForwardProp: prop => prop !== 'checked',
})<{ checked: boolean; style?: ContainerStyle }>(({ theme, checked, style }) => ({
    display: 'flex',
    justifyContent: 'stretch',
    width: '270px',
    height: `${style?.containerStyle.height ?? '64px'}`,
    backgroundColor: alpha(theme.palette.primary.main, 0.4),
    border: `1px solid ${alpha(theme.palette.primary.main, 0.8)}`,
    borderRadius: '8px',
    position: 'relative',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    '&:before': {
        backgroundColor: theme.palette.background.paper,
        content: "''",
        position: 'absolute',
        top: '6px',
        width: 'calc(50% - 12px)',
        height: `calc(${style?.containerStyle.height ?? '64px'} - 12px )`,
        borderRadius: '6px',
        transition: 'transform 0.3s',
        boxShadow: theme.palette.mode === 'dark' ? '0px 0px 16px 0px rgba(0, 0, 0, 0.35)' : '0px 0px 16px 0px rgba(0, 0, 0, 0.06)',
        transform: checked ? 'translateX(calc(100% + 18px))' : 'translateX(6px)',
        zIndex: 1,
        ...style?.animationStyle,
    },
    '& button': {
        flex: 1,
        border: 'none',
        borderRadius: 5,
        padding: '8px 16px',
        cursor: 'pointer',
        backgroundColor: 'transparent',
        outline: 'none',
        transition: 'all 0.3s ease',
        color: theme.palette.text.primary,
        zIndex: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        '&:hover': {
            // opacity: 0.8,
        },
        '&.active': {
            color: theme.palette.text.main,
            fontWeight: 600,
        },
        ...style?.buttonStyle,
    },
    ...style?.containerStyle,
}));

const CustomSwitch: React.FC<ToggleProps> = props => {
    const [value, setValue] = useState(props.value);

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    return (
        <Container checked={value === props.options[1]?.value} style={props.style}>
            {props.options.map(option => (
                <button
                    key={option.value}
                    className={value === option.value ? 'active' : ''}
                    onClick={() => {
                        setValue(option.value);
                        props.onChange(option.value);
                    }}>
                    {option.label}
                </button>
            ))}
        </Container>
    );
};

export default CustomSwitch;
